module.exports = __webpack_public_path__ + "img/success-white.180e517d.svg";